import { set } from 'cerebral/operators'

import getUserByToken from '../actions/getUserByToken.js'
import setRestoreUserId from '../actions/setRestoreUserId.js'

export default [
  set('state:client.currentPage', 'restorePassword'),
  getUserByToken,
  {
    success: [setRestoreUserId],
    error: []
  },
  set('state:login.recovery.restore.loaded', true)
]



// WEBPACK FOOTER //
// ./src/modules/login/chains/restorePassword.js